// extracted by mini-css-extract-plugin
export default {"pagination":"LUShZyTyq7cp46c5rrqf","pageItem":"kfzA2orkFNzNRT629Tbl","currentPage":"C_awPbfLg00X8N2m3LhA","pageLink":"oW5Bo8aLC4SThvXJBCnX"};